export default __webpack_public_path__ + "static/media/1031.91f19b7c.png";